export const q = q => document.querySelector(q)
export const qa = q => document.querySelectorAll(q)
export const byId = q => document.getElementById(q)
const first = (coll) => (coll && coll.length > 0) ? coll[0] : null
export const byClassAll = (cname, el) => (el || document).getElementsByClassName(cname)
export const byClass = (cname, el) => first(byClassAll(cname, el))

export function forEachNode(nodeList, cb) {
    if (nodeList.length === 0)  { return; }
    for (var i = -1, len = nodeList.length; ++i < len;) {
        cb(nodeList[i], i)
    }
}

export function appendNode(formErrors, options) {
    const node = document.createElement('div')
    node.classList.add(options.className)
    formErrors.append(node)
    return node
}

export function revealNode(node) {
    if (!node) { return }
    node.classList.remove('g-hidden')
}

export function hideNode(node) {
    if (!node) { return }
    node.classList.add('g-hidden')
}

export function hideAll(nodeList) {
    forEachNode(nodeList, hideNode)
}

export function tryRevealSelector(selector, ctx = document) {
    const node = ctx.querySelector(selector)
    if (node) {
        revealNode(node)
    } else {
        console.warn(`Selector ${selector} not found, not revealing`)
    }
}

export function tryHideSelector(selector, ctx = document) {
    const node = ctx.querySelector(selector)
    if (node) {
        hideNode(node)
    } else {
        console.warn(`Selector ${selector} not found, not revealing`)
    }
}

export function nodeListToArray(nodeList) {
    const arr = [];
    for (var i = -1, len = nodeList.length; ++i < len;) {
        arr.push(nodeList[i]);
    }
    return arr;
}



export function injectLink(opts) {
    const linkTag = document.createElement('link');
    linkTag.rel = opts.rel;
    linkTag.href = opts.href;
    if (opts.onload) {
        linkTag.onload = opts.onload;
    }
    document.head.appendChild(linkTag);
}



/**
 * Will return connection type from the browser API
 */
function getConnectionType() {
    const c1 = window.navigator.connection
    return c1 && c1.effectiveType;
}

/**
 * Will return connection downlink
 */
function getConnectionDownlink() {
    const c1 = window.navigator.connection
    return c1 && c1.downlink;
}

function isMobileUserAgent() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

function estimateDeviceType() {
    const isMobileMQ = window.matchMedia("only screen and (max-width: 760px)").matches
    const isMobileUA = isMobileUserAgent()
    if( isMobileMQ || isMobileUA ) {
        return 'mobile'
    }
    return 'desktop'
}

function estimateConnectionDownlink() {
    const deviceType = estimateDeviceType()
    if (['desktop', 'laptop'].includes(deviceType)) {
        return 10
    }
    return 2
}

export function hasGoodConnection() {
    try {
        const dl  = getConnectionDownlink()
        if (dl) {
            return dl > 8
        }
        //
        const edl = estimateConnectionDownlink()
        return edl > 8
    } catch (e) {
        return false
    }
}




export function getFormValuesShallow(form) {
    return nodeListToArray(form.elements).reduce((mem, element) => {
        if (element.type === 'submit' || element.classList.contains('autofill-decoy')) {
            return mem
        }
        if (element.type === "checkbox" && !element.checked) {
            return mem
        }
        switch (true) {
            case element.value === "false":
                mem[element.name] = false
                break
            case element.value === "true":
                mem[element.name] = true
                break
            default:
                mem[element.name] = element.value
        }
        return mem
    }, {});
}

window.gfv = getFormValuesShallow
